/* eslint-disable internal-rules/no-hardcoded-colors */
import { BuildingBlockLayouts, BuildingBlock } from '@pendo/services/BuildingBlocks';
import { getContent } from '@/guides/helpers/common.util.js';
import { buildResourceCenterBadge } from '@/utils/resource-center-helper.js';
import sharedServices from '@pendo/services/package.json';
import BuildingBlockGuidesService from '@/guides/services/building-blocks/building-block-guides';

function createBadge (resourceCenter, badgeSrcUrl) {
    const badgeBuildingBlocks = BuildingBlockLayouts.createBaseBuildingBlocksForLayout(
        'badgeResourceCenter',
        resourceCenter.id,
        { src: badgeSrcUrl },
    );
    const badgeDom = BuildingBlock.buildingBlocksToDom(badgeBuildingBlocks);

    resourceCenter.attributes.badge = {
        bbJson: badgeBuildingBlocks,
        color: '#FF4876',
        domJson: badgeDom,
        isOnlyShowOnce: false,
        name: 'pendo-chevron',
        position: 'inline',
        showBadgeOnlyOnElementHover: false,
        showGuideOnBadgeHover: false,
    };
}

function createResourceCenterAttribute (resourceCenter, isFullyCustom) {
    const { moduleIds } = BuildingBlockLayouts;

    resourceCenter.attributes.resourceCenter = {
        children: [],
        isTopLevel: true,
        moduleId: isFullyCustom ? moduleIds.fullyCustom : moduleIds.homeView,
        originId: resourceCenter.id,
    };
}

function createNotificationBubble (resourceCenter) {
    resourceCenter.attributes.notificationBubble = {
        'background-color': '#EC2059',
        'font-weight': 400,
        'font-family': 'inherit',
        'color': '#FFFFFF',
    };
}

function createBuildingBlocksAndDom (resourceCenter, isFullyCustom) {
    const { moduleIds, createResourceCenterBuildingBlocksForLayout } = BuildingBlockLayouts;

    const resourceCenterBuildingBlocks = createResourceCenterBuildingBlocksForLayout(
        isFullyCustom ? moduleIds.fullyCustom : moduleIds.homeView,
        resourceCenter.steps[0].id,
        { resourceCenterTitle: resourceCenter.name },
    );

    resourceCenter.steps[0].buildingBlocks = JSON.stringify(resourceCenterBuildingBlocks);
    resourceCenter.steps[0].dom = JSON.stringify(BuildingBlock.buildingBlocksToDom(resourceCenterBuildingBlocks));
}

function convertToFullyCustomResourceCenter (resourceCenter) {
    resourceCenter.steps[0].attributes.css =
        '/* Replace this default CSS to change the Resource Center container */\n' +
        'width: 350px;\n' +
        'height: 430px;\n' +
        'border: 1px solid black;\n' +
        'background-color: #FFFFFF;\n' +
        'border-radius: 3px;';

    resourceCenter.steps[0].content = '';

    BuildingBlockGuidesService.regenerateCodeBlockContent(resourceCenter.steps[0]).then((result) => {
        resourceCenter.steps[0] = result;
    });
}

export async function createDraftResourceCenter ({ resourceCenter, isFullyCustom, activeAppId }) {
    const badgeSrc = await buildResourceCenterBadge();
    resourceCenter.attributes.sharedServiceVersion = sharedServices.version;
    createBadge(resourceCenter, badgeSrc);
    createResourceCenterAttribute(resourceCenter, isFullyCustom);
    createNotificationBubble(resourceCenter);

    resourceCenter.appId = activeAppId;
    resourceCenter.name = 'Resource Center';
    resourceCenter.launchMethod = 'badge';
    // check if steps[0] is always defined when createGuide returns
    resourceCenter.steps[0].elementPathRule = 'body';

    createBuildingBlocksAndDom(resourceCenter, isFullyCustom);

    if (isFullyCustom) {
        convertToFullyCustomResourceCenter(resourceCenter);
    }

    return getContent(resourceCenter);
}
